/**
 * Formats estimated time in minutes to a human-readable string
 * @param minutes - Time in minutes
 * @returns Formatted time string (e.g., "30 minutes", "2 hours", "1 day")
 */
export const formatEstimatedTime = (minutes: number): string => {
  if (minutes < 60) {
    return `${minutes} minutes`;
  } else if (minutes < 1440) { // Less than 24 hours
    const hours = Math.round(minutes / 60);
    return `${hours} hour${hours !== 1 ? 's' : ''}`;
  } else {
    const days = Math.round(minutes / 1440);
    return `${days} day${days !== 1 ? 's' : ''}`;
  }
}; 